const CART_ADD = "/cart/add";
const CART_GET = "/cart";
const CART_UPDATE = "/cart/change";

// const cartDrawer = document.getElementById("CartDrawer"); // -> Uncomment to use cart drawer

document.querySelectorAll('form[data-from="product-card"]').forEach(form => {
  form.addEventListener('submit', handleAddToCart);
});

// document.querySelector('form[data-from="sticky-buy-buttons"]')?.addEventListener('submit', handleAddToCart); // -> Uncomment to use sticky buy buttons

document.body.addEventListener('click', e => {
  if (e.target.matches('[data-action="buy-now"]')) {
    handleBuyNow(e);
  } 
  // else if (e.target.matches('[data-type="minus"][data-is-from-cart]') || e.target.matches('[data-type="plus"][data-is-from-cart]') || e.target.matches('[data-type="remove"][data-is-from-cart]') || e.target.matches(".one-click-subscription")) {
  //   handleUpdateCart(e.target, e.target.closest("[data-quantity-selector]")); // -> Uncomment to use cart drawer
  // } 
  else if (e.target.matches('button[name="minus"]') || e.target.matches('button[name="plus"]')) {
    handleUpdateQuantitySelector(e.target);
  } // else if (e.target.matches(".cart-recommended-item__add")) {
    // addRecommendationToCart(e.target); // -> Uncomment to use cart drawer
  //}
  else if (e.target.matches('button[aria-controls="CartDrawer"]')) {
    window.location.href = "/cart"
  }
});

function handleUpdateQuantitySelector(button) {
  const quantitySelector = button.closest('[data-quantity-selector]');
  const input = quantitySelector.querySelector('input[name="quantity"]');
  const currentValue = parseInt(input.value) || 0;
  const min = parseInt(input.min) || 1;
  
  input.value = button.name === 'minus' 
    ? Math.max(min, currentValue - 1) 
    : currentValue + 1;
  
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function handleButtonLoading(btn) {
  btn.classList.toggle("btn--loading");
}

async function handleUpdateCartCount() {
  const cartInfo = await handleCartAction(CART_GET, "GET");

  const quantityCounter = document.querySelector("cart-count");
  quantityCounter.innerText = cartInfo.item_count;
}

async function handleAddToCart(e) {
  e.preventDefault()

  const form = e.target;
  const addToCartButton = form.querySelector("button[type=submit]");
  handleButtonLoading(addToCartButton);
  const formData = new FormData(form);

  if (form.dataset.subscription === "true") {
    formData.append("selling_plan", getSellingPlan(form));
  }
  else if (formData.get('selling_plan') == '') formData.delete("selling_plan");
  
  try {
    await handleCartAction(CART_ADD, "POST", formData);
    handleButtonLoading(addToCartButton);
    handleUpdateCartCount();
    const res = await handleCartAction(CART_GET, "GET");

    handleShowAddedToCartSuccessMessage(form) // -> Comment to use cart drawer
    // setRecommended(res.items[0].product_id); // -> Uncomment to use cart drawer
    // reloadCart(res.items, res.total_price)  // -> Uncomment to use cart drawer
    // cartDrawer.classList.add("active"); // -> Uncomment to use cart drawer
  } catch (error) {
    
  }
}

function handleBuyNow(e) {
  const form = e.target.closest('form');
  const formData = new FormData(form);
  const id = formData.get('id');
  const quantity = formData.get('quantity') || 1;
  const sellingPlan = e.target.dataset.subscription === "true" ? getSellingPlan(form) : formData.get('selling_plan');

  window.location.href = `https://blackforestsupplements.com/cart/add?items[0][id]=${ id }&items[0][quantity]=${ quantity }&${ sellingPlan != '' && sellingPlan != null ? `items[0][selling_plan]=${sellingPlan}&` : '' }return_to=/checkout`;
}

async function handleCartAction(url, method, body, headers) {
  try {
    const res = await fetch(url, {
      method: method,
      headers: {
        'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest', ...headers
      },
      ...(body && { body })
    })

    return await res.json();
  } catch (error) {
    console.error('Cart action failed:', error);
    throw error;
  }
}

function getSellingPlan(form) {
  const sellingPlan = form.querySelector("select.loop-selling-plan-selector").value;

  return sellingPlan;
}

function handleShowAddedToCartSuccessMessage(form) {
  const message = form.querySelector(".ajaxified-cart-feedback");
  message?.classList.add("active");
}


